<template>
  <div class="row">
    <b-col
      class="bg-white guide-left-nav col-custom col-auto"
      :class="{'show': showguide }"
    >
      <div
        class="close-m-list"
        @click="hideGuide"
      >
        <img
          :src="require('@/assets/images/close.png')"
          alt=""
        >
      </div>
      <left-nav />
    </b-col>
    <b-col
      class="custom-col-12"
    >
      <router-view :key="$route.fullPath" />
    </b-col>
    <div
      class="user-guide-m-but"
      :class="{'hide': showguide , 'play': playguide}"
      @click="showGuide"
    >
      <svg
        x="0px"
        y="0px"
        viewBox="0 0 89.475 89.475"
      >
        <g>
          <path
            style="fill:#fff;"
            d="M76.264,0.111v33.426l-8.675-7.283l-8.675,7.283V0H14.317c-0.122,0-0.236,0.032-0.358,0.036v5.519 h-2.863V0.394C4.747,1.861,0.002,7.519,0.002,14.315v60.84c0,6.793,4.746,12.454,11.094,13.925V83.92h2.863v5.519 c0.122,0.004,0.236,0.036,0.358,0.036h60.84c7.906,0,14.315-6.41,14.315-14.315v-60.84C89.473,6.786,83.643,0.684,76.264,0.111z M13.959,76.791h-2.863v-7.122h2.863V76.791z M13.959,62.548h-2.863v-7.122h2.863V62.548z M13.959,48.297h-2.863v-7.122h2.863 V48.297z M13.959,34.053h-2.863v-7.122h2.863V34.053z M13.959,19.805h-2.863v-7.122h2.863V19.805z"
          />
        </g>
      </svg>
    </div>
  </div>
</template>
<script>
import {
  BCol,
} from 'bootstrap-vue'

import leftNav from '@/views/guide/LeftNav.vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'MainUserGuide',
  components: {
    BCol,
    leftNav,
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('userguide', {
      showguide: 'getShowGuide',
      playguide: 'getAnimGuide',
    }),
  },
  mounted() {},
  methods: {
    ...mapMutations('userguide', {
      setShowGuid: 'SET_SHOW_GUIDE',
      setAnimGuid: 'SET_ANIM_GUIDE',
    }),
    showGuide() {
      this.setShowGuid(true)
      this.setAnimGuid(false)
    },
    hideGuide() {
      this.setShowGuid(false)
    },
  },
}
</script>
<style scoped>
.col-custom {
  min-width: 305px;
}
.custom-col-12 {
  width: calc(100% - 315px);
}
.pt-15 {
    padding-top: .1rem;
}
</style>
